import axios from "axios";
import { getData } from "./dataHelper";
import store from "../store/index";
import { SentryService } from "./sentryService";
import { AUTH_TYPES, STORE_TYPES, HELPER_TYPES } from "../store/types";

const ApiService = {
    init() {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;

        this.setHeader();
        axios.interceptors.response.use(
            (response) => response,
            (error) => this.errorHandler(error)
        );
    },

    setHeader() {
        axios.defaults.withCredentials = true;
        axios.defaults.headers = {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        };
    },
    errorHandler(error) {
        if (getData(error, "response.status") == 401) {
            console.log("NOT AUTHORIZED");
            store.dispatch(`${STORE_TYPES.AUTH}/${AUTH_TYPES.LOGOUT}`);
        } else if (getData(error, "response.status") == 404) {
            console.log("NOT FOUND");
        } else if (getData(error, "response.status") == 422) {
            if (getData(error, "response.data")) {
                store.commit(
                    `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_ERROR_ID_OBJECT}`,
                    getData(error, "response.data.errors")
                );
            }
        }
        if (getData(error, "response.status") != 401) {
            SentryService.sendError({
                message: "Network Error",
                jsonObject: error,
            });
        }
        throw error;
    },
    query(resource, params) {
        return axios.get(resource, params).catch((error) => {
            return error;
        });
    },

    get(resource, slug = "") {
        return axios.get(`${resource}/${slug}`).catch((error) => {
            return error;
        });
    },
    async uploadDocument({ resource, params }) {
        return axios
            .post(resource, params, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error;
            });
    },

    async post(resource, params, config) {
        return await axios
            .post(`${resource}`, params, config)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error;
            });
    },
    async put(resource, params, config) {
        return await axios
            .put(`${resource}`, params, config)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error;
            });
    },

    update(resource, slug, params) {
        return axios
            .put(`${resource}/${slug}`, params)
            .then((response) => {
                return response;
            })
            .catch(() => {
                return;
            });
    },
    updateSingle(resource, params) {
        return axios
            .put(`${resource}`, params)
            .then((response) => {
                return response;
            })
            .catch(() => {
                return;
            });
    },

    destroy(resource, slug) {
        return axios.delete(`${resource}/${slug}`).catch((error) => {
            return error;
        });
    },
    delete(resource) {
        return axios.delete(resource).catch((error) => {
            return error;
        });
    },
};

export default ApiService;
